import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-cmdb-sync-settings-skeleton',
  templateUrl: './cmdb-sync-settings-skeleton.component.html',
  styleUrls: ['./cmdb-sync-settings-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class CmdbSyncSettingsSkeletonComponent {}